import React from 'react'
import { Button } from './styles'
import type { ConnectorProps as ListProps } from '../../connectors/Collection'
import CollectionConnector from '../../connectors/Collection'
import { SEE_MORE_TOOLTIP } from '../../helpers/constants'



export default CollectionConnector(
  (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { updateCollectionTypeUrl, featuredSectionData, pageSlugifyDictionary } = props

    const getUrlValueFromDictionary = (section) => {
      return pageSlugifyDictionary[section]
    }

    const openNewThisWeek = (ev) => {
      ev.preventDefault()
      updateCollectionTypeUrl(getUrlValueFromDictionary(featuredSectionData.collectionName))

      if (window.scrollY < 350) {
        window.scrollBy(0, 900)
      } else {
        window.scrollBy(0, 600)
      }
    }

    return (
      <Button onClick={(ev) => openNewThisWeek(ev)} title={SEE_MORE_TOOLTIP}>
        <p className='defaultTypographySmall'>
          See More
        </p>
      </Button>
    )
  }
)